<footer>
  <address
    fxLayout="column"
    fxLayout.gt-xs="row"
    class="container"
  >
    <a
      fxHide
      fxFlex
      fxShow.gt-md
      fxLayout="row"
      [routerLink]="basePath"
    >
      <img
        [src]="agencyService.agency.logo.url ? agencyService.agency.logo.url : '/assets/icons/logo_footer.svg'"
        [alt]="agencyService.agency.name"
        loading="lazy"
      >
    </a>
    <a
      [href]="'tel:' + agencyService.agency.phone"
      fxFlex
      target="_blank"
      fxLayout="column"
      fxLayoutAlign="start center"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="phone_click"
      appFbqEvent="Contact"
      [customData]="{content_name: 'phone_click', content_category: 'click'}"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center"
      >
        <img src="/assets/icons/contact/phone.svg" alt="">
        <h6>
          Telefon
        </h6>
      </div>
      {{ agencyService.agency.phone | beautify }}
    </a>
    <a
      fxFlex
      [href]="'https://maps.google.com?daddr='
      + agencyService.agency.latitude + ','
      + agencyService.agency.longitude + '&amp;ll='"
      target="_blank"
      fxLayout="column"
      fxLayoutAlign="start center"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="maps_click"
      appFbqEvent="Contact"
      [customData]="{content_name: 'maps_click', content_category: 'click'}"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center"
      >
        <img src="/assets/icons/contact/location.svg" alt="">
        <h6>
          Adresa
        </h6>
      </div>
      {{ agencyService.agency.address }}
    </a>
    <a
      fxFlex
      [href]="'mailto:' + agencyService.agency.email"
      target="_blank"
      fxLayout="column"
      fxLayoutAlign="start center"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="email_click"
      appFbqEvent="Contact"
      [customData]="{content_name: 'email_click', content_category: 'click'}"
    >
      <div
        fxLayout="row"
        fxLayoutAlign="center"
      >
        <img src="/assets/icons/contact/email.svg" alt="">
        <h6>
          E-mail
        </h6>
      </div>
      {{ agencyService.agency.email }}
    </a>
    <div fxFlex>
      <img
        class="cert"
        src="/assets/icons/iso.webp"
        alt="ISO 9001"
        loading="lazy"
      >
      <img
        class="cert"
        src="/assets/icons/cert.png"
        alt="Certificat"
        loading="lazy"
      >
    </div>
    <a
      fxFlex
      fxLayout="column"
      fxLayoutAlign="start center"
      class="developed-by-section footer-item"
      href="https://vaunt.ro/"
      target="_blank"
    >
      <h6>
        Website dezvoltat de:
      </h6>
      <img
        src="/assets/icons/vaunt_logo.svg"
        alt="logo vaunt"
        class="logo-vaunt"
      >
    </a>
  </address>
  <div class="container disclaimer">
    <div class="disclaimer-copy">
      Toate materialele și randarile au exclusiv scop de prezentare, fără a crea obligații sau răspunderi legale sau contractuale în sarcina dezvoltatorului sau a clientului. Dezvoltatorul își rezervă dreptul de a modifica conținutul și structura prezentării în orice moment.
      <br>
      Copyright ©{{ date.getFullYear() }} SC HOME STORE INVESTMENT SRL
    </div>
    <div class="disclaimer-images">
      <a href="https://anpc.ro/ce-este-sal/">
        <img src="/assets/images/anpcimg1.png" alt="SAL">
      </a>
      <a href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO">
        <img src="/assets/images/anpcimg2.png" alt="ANPC">
      </a>
    </div>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/shared/footer/footer.component.html